export enum PaymentLineItemType {
  Fee = 0,
  Discount = 1
}